export default build =>
    build.query({
        query() {
            return {
                url: `/exam/getdistrict`,
                method: 'GET',
            };
        }
    })
